import React from 'react'

const Acknowledgement = () => {
  return (

      <div className="main_page_container">
        <div className="page_heading">
          <h1>Acknowledgement</h1>

        </div>
        <div className="page_section">
          <p>
            I would like to express my sincere gratitude and appreciation to the Department of Geo-Engineering, Andhra University, and specifically to my research guide, Prof. P. Jagadeeswara Rao, for his invaluable support and guidance in completing this project.
          </p>

        </div>


      </div>

  )
}

export default Acknowledgement